<template>
    <div class="set-password">
        <img
            src="/images/logo.png"
            alt="goTenna Pro Management Portal"
            class="logo"
        />

        <form @submit.prevent="updateUser">
            <p class="copy">Please complete your <em>admin</em> account creation.</p>

            <div class="form-group">
                <label for="name">Name</label>
                <input
                    id="name"
                    v-model="name"
                    type="text"
                    required
                    maxlength="60"
                />
            </div>

            <div class="form-group">
                <label for="title">Title</label>
                <input
                    id="title"
                    v-model="title"
                    type="text"
                    maxlength="60"
                />
            </div>

            <div class="form-group">
                <label for="username">Username</label>
                <input
                    id="username"
                    v-model="username"
                    type="text"
                    required
                    maxlength="32"
                />
            </div>

            <div class="form-group">
                <label for="password">Password</label>
                <input
                    id="password"
                    v-model="password"
                    type="password"
                    required
                    maxlength="255"
                />
            </div>

            <div class="form-group">
                <label for="password_confirmation">Confirm Password</label>
                <input
                    id="password_confirmation"
                    v-model="passwordConfirmation"
                    type="password"
                    required
                    maxlength="255"
                />
            </div>

            <form-errors :response="errorResponse"></form-errors>

            <div class="form-group">
                <button
                    type="submit"
                    class="btn"
                    :class="{ active: submitted }"
                >
                    <div>Submit</div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'

export default {
    components: {
        FormErrors,
    },

    props: ['token'],

    data() {
        return {
            password: null,
            passwordConfirmation: null,
            name: null,
            title: null,
            username: null,
            submitted: false,
            errorResponse: null,
        }
    },

    mounted() {
        this.$emit('step', 2)
    },

    methods: {
        updateUser() {
            if (this.submitted) {
                return
            }

            this.submitted = true

            this.$http
                .put(`onboarding/admin/${this.token}/user`, {
                    name: this.name,
                    title: this.title,
                    username: this.username,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                })
                .then(({ data }) => {
                    const admin = data

                    this.$store
                        .dispatch('login', {
                            organization: admin.organization.name,
                            email: admin.email,
                            password: this.password,
                        })
                        .then((result) => {
                            this.$router.push('/onboarding/terms-of-service')
                        })
                        .catch((error) => {
                            this.submitted = false
                            // this.errorResponse = error.response
                        })
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },
    },
}
</script>
